// @flow
import React from 'react';
import styled from 'styled-components';
import { Alert as BSAlert } from 'reactstrap';
import type { ColorType, ThemeType, BootstrapColorNameType } from 'trustar-2.0/types';
import { CircleIcon, IconLookup } from './Icon/index';
import { IconType } from 'trustar-2.0/types';
import { DefaultTheme } from 'trustar-2.0/themes';
import { desaturate } from 'polished';
import { Container, Row, Col } from 'reactstrap';

const { ThemeColors } = DefaultTheme;

type AlertPropType = {
  className?: string,
  closeClassName?: string,
  isOpen?: boolean,  // default: true
  toggle?:Function,
  tag?: (Function | string),
  children: any,
  theme: ThemeType,
  fontSize?: string,
  fontWeight?: string,
  color: BootstrapColorNameType,// Controls the transition of the alert fading in and out
  // See Fade for more details
  // transition: PropTypes.shape(Fade.propTypes),
};

type BaseAlertPropType = AlertPropType & {
  icon: IconType,
  backgroundColor: Object,
};

const defaultProps = {
  isOpen: true,
  theme: DefaultTheme,
  bsColor: 'warning',
};

const StyledBSAlert = styled(BSAlert)`
  margin-bottom: 1.416666667rem !important;
`;

const BaseAlert = (props: BaseAlertPropType) => {

  const FlexContainer = styled.div`
    && {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;
      min-width: 11rem;
    }
  `;

  const FlexItem = styled.div`

  `;
  const AlertText = styled.span`
    font-weight: 600;
    vertical-align: middle;

    & > p:last-child {
      margin-bottom: 0;
    }

    & .diff-link,
    & .diff-link:hover {
      color: inherit;
      text-decoration: underline;
    }

    & a:not(.diff-link) {
      text-decoration: none;
      border-bottom: 3px solid ${props.backgroundColor.hex};

      &:hover {
        text-decoration: none !important;
        border-bottom: 3px solid ${desaturate(0.6, props.backgroundColor.hex)};
      }
    }
  `;

  return (
    <StyledBSAlert color={props.color}>
      <FlexContainer>
        <div css={`
          && {
            order: 1;
            flex: 0 1 auto;
            align-self: auto;
            margin-right: 1.5rem;
          }
        `}>
          <CircleIcon
            fontSize={props.fontSize}
            icon={props.icon}
            backgroundColor={props.backgroundColor.hex}
              />
        </div>
        <div css={`
          && {
            order: 2;
            flex: 1 1 auto;
            align-self: auto; 
          }
        `}>
          <AlertText dangerouslySetInnerHTML={{ __html: props.children }} />
        </div>
      </FlexContainer>
    </StyledBSAlert>);
};

BaseAlert.defaultProps = defaultProps;

export const Alert = (props: AlertPropType) => {
  const { ThemeColors } = props.theme;
  switch(props.color) {
  case 'primary':
    return <BaseAlert backgroundColor={ThemeColors.PRIMARY} icon={IconLookup.CROSS} color='primary' {...props} />;
  case 'secondary':
    return <BaseAlert backgroundColor={ThemeColors.SECONDARY} icon={IconLookup.EXCLAMATION} color='secondary' {...props} />;
  case 'warning':
    return <BaseAlert backgroundColor={ThemeColors.WARNING} icon={IconLookup.EXCLAMATION} color='warning' {...props} />;
  case 'success':
    return <BaseAlert backgroundColor={ThemeColors.SUCCESS} icon={IconLookup.CHECK} color='success' {...props} />;
  case 'danger':
    return <BaseAlert backgroundColor={props.theme.ThemeColors.DANGER} icon={IconLookup.CROSS} color='danger' {...props} />;
  case 'info':
    return <BaseAlert backgroundColor={ThemeColors.INFO} icon={IconLookup.CROSS} color='info' {...props} />;
  default:
    return <BaseAlert backgroundColor={ThemeColors.INFO} icon={IconLookup.CROSS} color='info' {...props} />;
  }
};

Alert.defaultProps = {
  theme: DefaultTheme,
};

export const AlertLink = (props: Object) => {
  return <a className={'alert-link'} {...props} />;
};

AlertLink.defaultProps = {
  theme: DefaultTheme,
};

export default Alert;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Alert.js